import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {ITestKitOrderPayload} from '../TestKitOrder.ts';
import {TestKitOrderApi} from '../../../apis/TestKitOrderApi/TestKitOrderApi.ts';
import {useIdFromRoute} from '../../../hooks/useIdFromRoute.tsx';

export function usePuTestKitOrder() {
    const id = useIdFromRoute()
    const queryClient = useQueryClient();
    
    return useMutation<number, AppMedError, ITestKitOrderPayload>({
        mutationKey: [QueryKeys.testkitorder],
        mutationFn: async (variables: ITestKitOrderPayload) => {
            return await TestKitOrderApi.putTestKitOrder(id!, variables);
        },
        onSuccess: async (code: number) => {
            queryClient.setQueryData<number>([QueryKeys.testkitorder], () => {
                return code;
            });
        },
    });
}